import { render, staticRenderFns } from "./nbn-check-list-details-fttn-fttb.vue?vue&type=template&id=5237999c&scoped=true"
import script from "./nbn-check-list-details-fttn-fttb.vue?vue&type=script&lang=js"
export * from "./nbn-check-list-details-fttn-fttb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5237999c",
  null
  
)

export default component.exports